
import JSONFormatter, { type JSONFormatterConfiguration } from 'json-formatter-js';

import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'lib-json-display',
  standalone: true,
  imports: [],
  templateUrl: './json-display.component.html',
  styleUrls: ['./json-display.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class JsonDisplayComponent implements AfterViewInit, OnChanges {
  @Input() json: unknown = null;
  @ViewChild('jsonHost') private jsonHost?: ElementRef<HTMLDivElement>;

  private isViewInitialized = false;
  private readonly formatterConfig: JSONFormatterConfiguration = {
    animateClose: false,
    animateOpen: false,
    hoverPreviewEnabled: false,
    theme: 'dark',
  };

  ngAfterViewInit(): void {
    this.isViewInitialized = true;
    this.renderJson();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['json'] && this.isViewInitialized) {
      this.renderJson();
    }
  }

  private renderJson(): void {
    const host = this.jsonHost?.nativeElement;

    if (!host) {
      return;
    }

    host.replaceChildren();

    if (this.json === null || this.json === undefined) {
      return;
    }

    if (typeof this.json !== 'object') {
      host.textContent = JSON.stringify(this.json, null, 2) ?? String(this.json);
      return;
    }

    const formatter = new JSONFormatter(this.json, 1, this.formatterConfig);
    host.appendChild(formatter.render());
  }
}
